export default {
    SUBMIT_IMPORTAR_VERRACOS: 'SUBMIT_IMPORTAR_VERRACOS',
    SUBMIT_IMPORTAR_VERRACOS_SUCCESS: 'SUBMIT_IMPORTAR_VERRACOS_SUCCESS',
    ABRIR_MODAL_IMPORTAR_VERRACOS: 'ABRIR_MODAL_IMPORTAR_VERRACOS',
    CERRAR_MODAL_IMPORTAR_VERRACOS: 'CERRAR_MODAL_IMPORTAR_VERRACOS',
    SUBIR_ARCHIVOS_IMPORTAR_VERRACOS: 'SUBIR_ARCHIVOS_IMPORTAR_VERRACOS',
    DESCARGAR_PLANTILLA_EXCEL_VERRACOS: 'DESCARGAR_PLANTILLA_EXCEL_VERRACOS',
    DESCARGAR_VERRACOS: 'DESCARGAR_VERRACOS'
  }